export const getTitleCase = (string: string | null) => {
  if (!string) {
    return '';
  }
  return string
    .split(' ')
    .map((word) => {
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(' ');
};
